import { isEmpty, pick } from 'lodash';
import { createSelector } from 'reselect';
import { PRICING_SECTION } from 'redux/actions/availability';

export const getAllResources = (state) => state.resources;
export const getProductResourceIds = (_state, props) => props.resourceIDs;
export const getProductResources = createSelector(
  [getAllResources, getProductResourceIds],
  (allResources, resourceIDs) => pick(allResources, resourceIDs)
);

export const getSelectedResourceId = (_state, props) =>
  props.selectedResourceId;
export const getSelectedDate = (_state, props) => props.selectedDate;
export const getChildResources = createSelector(
  [getAllResources, getSelectedResourceId, getSelectedDate],
  (allResources, selectedResourceId, selectedDate) => {
    if (
      isEmpty(allResources) ||
      isEmpty(selectedDate) ||
      selectedResourceId === undefined
    ) {
      return;
    }

    const resource = allResources[selectedResourceId];
    if (isEmpty(resource)) {
      return;
    }

    const childResourceIds = resource.childResources || [];

    return childResourceIds
      .map((child) => allResources[child.id])
      .filter((child) => {
        if (isEmpty(child)) {
          return false;
        }

        return child.bookability[selectedDate]?.available;
      });
  }
);

export const getAllPassengerTypes = (state) => state.types?.passengerTypes;
export const getProductPassengerTypeIds = (_state, props) =>
  props.passengerTypeIDs;
export const getProductPassengerTypes = createSelector(
  [getAllPassengerTypes, getProductPassengerTypeIds],
  (allPassengerTypes, passengerTypeIDs) =>
    pick(allPassengerTypes, passengerTypeIDs)
);

export const getPricePerPaxType = createSelector(
  [getAllResources, getSelectedResourceId, getSelectedDate],
  (allResources, selectedResourceId, selectedDate) => {
    if (
      isEmpty(allResources) ||
      isEmpty(selectedDate) ||
      selectedResourceId === undefined
    ) {
      return;
    }

    const resource = allResources[selectedResourceId];
    if (isEmpty(resource) || isEmpty(resource?.pricing)) {
      return;
    }

    return resource.pricing[PRICING_SECTION.passenger][selectedDate]
      ?.pricing_details?.price_per_pax_type;
  }
);

export const getBookability = createSelector(
  [getAllResources, getSelectedResourceId, getSelectedDate],
  (allResources, selectedResourceId, selectedDate) => {
    if (
      isEmpty(allResources) ||
      isEmpty(selectedDate) ||
      selectedResourceId === undefined
    ) {
      return;
    }

    const resource = allResources[selectedResourceId];
    if (isEmpty(resource) || isEmpty(resource?.bookability)) {
      return;
    }

    return resource.bookability[selectedDate];
  }
);
